import React from "react";
import { CheckCircle2 } from "lucide-react";

const points = [
  "Distributeur en France de MeMed Key® & MeMed BV®",
  "Solutions diagnostiques à forte valeur médicale, clinique et économique",
  "Accompagnement des établissements de santé et laboratoires de biologie médicale",
  "Engagement actif dans la lutte contre l'antibiorésistance",
];

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1 nx-fade">
          <div className="relative rounded-3xl overflow-hidden border border-white/10">
            <div
              className="absolute inset-0 z-10"
              style={{
                background:
                  "linear-gradient(180deg, rgba(6,11,25,0) 40%, rgba(6,11,25,0.7) 100%)",
              }}
            />
            <img
              src="https://customer-assets.emergentagent.com/job_nexo-branding/artifacts/bhg8f3hf_maxresdefault.jpg"
              alt="Médecin utilisant MeMed Key® en consultation"
              className="w-full h-[480px] md:h-[560px] object-cover"
            />
            <div className="absolute z-20 bottom-6 left-6 right-6 flex items-center justify-between bg-[#0A1128]/85 backdrop-blur-xl rounded-2xl border border-white/10 px-5 py-4">
              <div>
                <div className="text-[11px] uppercase tracking-wider text-slate-400">
                  Nexodiag · France
                </div>
                <div className="font-display text-lg">
                  Distributeur officiel MeMed
                </div>
              </div>
              <div className="text-xs font-medium px-3 py-1.5 rounded-full bg-[#5BC4D1]/15 text-[#5BC4D1] border border-[#5BC4D1]/30">
                Nouveauté 2026
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2 nx-fade">
          <div className="text-xs uppercase tracking-[0.2em] text-[#5BC4D1] font-medium mb-4">
            À propos de Nexodiag
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-tight tracking-tight">
            L&apos;innovation diagnostique{" "}
            <span className="font-semibold">au service du soin.</span>
          </h2>
          <p className="mt-6 text-slate-300 leading-relaxed">
            Nexodiag est une société française spécialisée dans la commercialisation
            de solutions diagnostiques innovantes destinées aux laboratoires de
            biologie médicale et aux établissements de santé. Notre mission&nbsp;:
            fournir aux professionnels de santé les outils permettant
            d&apos;améliorer la prise en charge des patients tout en contribuant
            à l&apos;efficience du système de soins.
          </p>

          <ul className="mt-8 space-y-3">
            {points.map((p, i) => (
              <li
                key={p}
                data-testid={`about-point-${i}`}
                className="flex items-start gap-3 text-slate-200"
              >
                <CheckCircle2
                  size={20}
                  className="text-[#5BC4D1] mt-0.5 shrink-0"
                />
                <span className="text-sm md:text-base">{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 p-6 rounded-2xl border border-white/10 bg-[#0E1530]">
            <p className="text-slate-200 leading-relaxed italic text-[15px]">
              «&nbsp;Avec MeMed BV, les cliniciens disposent d&apos;une
              information objective et fiable fondée sur la réponse immunitaire
              du patient, leur permettant d&apos;améliorer la prise de décision
              tout en participant activement à la lutte contre l&apos;antibiorésistance.&nbsp;»
            </p>
            <div className="mt-4 text-sm text-slate-400">
              <span className="text-white font-medium">Anthony Verlot</span>
              {" — "}Directeur Commercial France, Nexodiag
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
